import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import ScreenSize from "screen-size-vue";
Vue.use(ScreenSize);

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = "https://exams.weybanskytech.com.ng/api/";
} else {
  axios.defaults.baseURL = "http://adroit-learners.local/api/";
  // axios.defaults.baseURL = "http://127.0.0.1:8000/api/";
}
// axios.defaults.withCredentials = true;

const token = localStorage.getItem("token");
axios.defaults.headers.common["Authorization"] = "Bearer " + token;

// TODO - Dowload a Pace,js package
let numberOfAjaxCallPending = 0;
axios.interceptors.request.use(
  function(config) {
    numberOfAjaxCallPending++;
    if (window.Pace) window.Pace.restart();
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    numberOfAjaxCallPending--;
    if (numberOfAjaxCallPending == 0) if (window.Pace) window.Pace.stop();
    return response;
  },
  function(error) {
    numberOfAjaxCallPending--;
    if (numberOfAjaxCallPending == 0) if (window.Pace) window.Pace.stop();
    return Promise.reject(error);
  }
);
// end - PACE

axios.interceptors.response.use(undefined, function(err) {
  return new Promise(function() {
    if (
      err.response.status === 401 &&
      err.response.config &&
      !err.response.config.__isRetryRequest
    ) {
      store.dispatch("auth/logout");
    }
    throw err;
  });
});

// 500 error response
axios.interceptors.response.use(undefined, function(err) {
  return new Promise(function() {
    if (
      err.response.status === 500 &&
      err.response.config &&
      !err.response.config.__isRetryRequest
    ) {
      err.response.data.message = "Something went wrong";
    }
    throw err;
  });
});

// 405 error response
axios.interceptors.response.use(undefined, function(err) {
  return new Promise(function() {
    if (
      err.response.status === 405 &&
      err.response.config &&
      !err.response.config.__isRetryRequest
    ) {
      err.response.data.message = "Something went wrong//";
    }
    throw err;
  });
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
